module.exports = __webpack_public_path__ + "img/iimage.2c25011e.svg";